<template>
  <div>
    <c-card
      v-for="(rating, rid) in ratings"
      :key="rid"
    >

      <c-rating
        v-if="rating.rating"
        :comment="rating.rating.comment"
        :date="new Date(rating.rating.date)"
        :rating="parseInt(rating.rating.value)"
      />

      <div v-else>
        <p>Bewertung für <strong>{{ rating.period }}</strong> fehlt.</p>
        <c-button-router-link
          v-if="allowRating"
          :to="{
            name: 'process-rating-add',
            params: { identifier: process.identifier, period: rating.period }
          }"
        >
          Jetzt bewerten
        </c-button-router-link>
      </div>

    </c-card>
  </div>
</template>

<script>
import CCard from '@/components/CCard'
import CGrid from '@/components/CGrid'
import CGridItem from '@/components/CGridItem'
import CRating from '@/components/CRating'
import CTitle from '@/components/CTitle'
import CButtonRouterLink from '@/components/CButtonRouterLink'

export default {
  name: 'CProcessRatingListCards',

  components: {
    CCard,
    CGrid,
    CGridItem,
    CRating,
    CTitle,
    CButtonRouterLink
  },

  props: {
    ratings: {
      type: Array,
      required: true
    },

    process: {
      type: Object,
      required: true
    },

    allowRating: {
      type: Boolean
    }
  },

  methods: {
    formatPeriod (period) {
      return period.split('.').reverse().join('.')
    }
  }
}
</script>
